import Button from "./PriceButton"
import React, { Component } from 'react';
import cents from "../images/less-than-20-cents-white.png"
import styles from "../styles/twostep.module.scss"

class TwoSteps extends React.Component {
  constructor(){
    super()
    this.state = {
      haveEthos:false,
      ethosTitle1: '',
      ethosTitle2: '',
      ethosTitle3: '',
      ethosTitle4: '',
      ethosTitle5: '',
    }
  }


  componentDidMount(){
    const finalEthos = localStorage.getItem('haveEthos')
    const ethos1=localStorage.getItem('ethos1Title')
    const ethos2=localStorage.getItem('ethos2Title')
    const ethos3=localStorage.getItem('ethos3Title')
    const ethos4=localStorage.getItem('ethos4Title')
    const ethos5=localStorage.getItem('ethos5Title')

    
    if(finalEthos==='true'){
      this.setState({
        haveEthos:finalEthos,
        ethosTitle1:ethos1,
        ethosTitle2:ethos2,
        ethosTitle3:ethos3,
        ethosTitle4:ethos4,
        ethosTitle5:ethos5,
      })
    }
    
  }



  render(){

  return (
    <section className={styles.signUp}>
      <div className={styles.signUp_value}>
        <div className={styles.signUp_value_steps}>
          <h2 class="white">
            <span className={styles.signUp_value_steps_numbers}>1</span> Take your Ethos Evaluation 
          </h2>
          <h2 class="white">
            <span className={styles.signUp_value_steps_numbers}>2</span> Buy the Full Power Program
          </h2>
          <h2 class="white">
            <span className={styles.signUp_value_steps_numbers}>3</span> Start Your 7 Weeks of em•powerment Training!
          </h2>
        </div>
        <div className={styles.signUp_value_cost}>
          <img src={cents} alt="less than 20 cents a day" />
          <div className={styles.c_button}>
            {this.state.haveEthos?  
            <Button
            href={`https://member.empowerofyou.com/checkout/?add-to-cart=4741&ethos1=${this.state.ethosTitle1}&ethos2=${this.state.ethosTitle2}&ethos3=${this.state.ethosTitle3}&ethos4=${this.state.ethosTitle4}&ethos5=${this.state.ethosTitle5}`}
            backgroundColor={"#9FE5E3"}
            label={"FULL POWER PROGRAM"}
            fontSize={"22px"}
            price={"5.99"}
            length={"month"}
            />
            : 
            <Button
              href={"https://member.empowerofyou.com/checkout/?add-to-cart=4741"}
              backgroundColor={"#9FE5E3"}
              label={"FULL POWER PROGRAM"}
              fontSize={"22px"}
              price={"5.99"}
              length={"month"}
            />
  }
            <p>
              workouts <span className={styles.blue}>|</span> meditations{" "}
              <span className={styles.blue}>|</span> challenges
            </p>
          </div>
        </div>
      </div>
    </section>
  )
  }
}

export default TwoSteps
